import React, { useContext, useEffect } from 'react'

import FilterMultipleValueInput from '.'
import useAxios from 'hooks/useAxios'
import { getOptionDiscriminator } from 'libs/filter-rule-discriminator'
import { filterGroupContext, useFeedbackIndexActions } from 'shared/components/FilterGroup/context'

/** @typedef {import('shared/components/FilterGroup/reducer').Filter} Filter */
/** @typedef {import('shared/components/FilterGroup/container').Extra} Extra */

/** @param {import('shared/components/FilterGroup/reducer').InputProps<Extra>} props */
export default function FilterMultipleValueInputContainer({
  rule,
  defaultFilters,
  onChange,
  isMultipleValue = true,
}) {
  const { data, loading, fetch } = useAxios({
    url: 'reports/autocomplete/',
    method: 'post',
    skip: true,
  })

  const cachedOptionKey = rule.field + getOptionDiscriminator(rule.extra)
  const options = useOptions(cachedOptionKey, data)

  usePrefetchOptions(options, rule, fetch)

  function handleSearchChange(searchQuery) {
    let postData = {
      attribute: rule.extra && rule.extra.attribute,
      role: rule.extra && rule.extra.role,
      field: rule.field,
      value: searchQuery,
    }

    if (rule.field === 'topic.pair.sentiment') {
      postData = {
        field: 'topic',
        value: searchQuery,
      }
    }

    fetch({
      data: postData,
    })
  }

  const optionsFromDefaultFilters = createOptionsFromDefaultFilters(defaultFilters)
  const uniqueOptions = optionsFromDefaultFilters
    .filter((defaultOption) => !options.some((option) => option.value === defaultOption.value))
    .concat(options)

  return (
    <FilterMultipleValueInput
      searching={loading}
      defaultFilters={defaultFilters}
      onChange={onChange}
      options={uniqueOptions}
      onSearchChange={handleSearchChange}
      isMultipleValue={isMultipleValue}
    />
  )
}

/** @param {Filter[]} defaultFilters */
function createOptionsFromDefaultFilters(defaultFilters) {
  if (defaultFilters) {
    return defaultFilters.map((filter) => {
      return {
        text: filter.label,
        value: filter.value,
      }
    })
  }

  return []
}

function useOptions(key, autocompleteResults) {
  const { cachedOptions, dispatch } = useContext(filterGroupContext)
  const options = cachedOptions[key] || []
  const actions = useFeedbackIndexActions(dispatch)
  useEffect(() => {
    if (autocompleteResults && autocompleteResults instanceof Array) {
      actions.setCacheOptions(
        key,
        autocompleteResults.map(({ id, label, value, description }) => {
          return {
            key: id ?? value,
            text: label,
            value,
            description,
          }
        })
      )
    }
  }, [actions, autocompleteResults, key])

  return options
}

function usePrefetchOptions(options, rule, fetch) {
  useEffect(() => {
    if (options.length === 0) {
      const searchQuery = ''
      let postData = {
        attribute: rule.extra && rule.extra.attribute,
        role: rule.extra && rule.extra.role,
        field: rule.field,
        value: searchQuery,
      }

      if (rule.field === 'topic.pair.sentiment') {
        postData = {
          field: 'topic',
          value: searchQuery,
        }
      }

      fetch({
        data: postData,
      })
    }
  }, [fetch, options.length, rule.extra, rule.field])
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/FilterMultipleValueInput/container.js